<template>
  <div class="notificator">
    <div
      class="notification"
      v-for="(notification, key) in notifications"
      :key="key"
      :class="notification.level"
      @click="click($event, key)"
    >{{ notification.text }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "notificator",
  computed: {
    ...mapState(["notifications"])
  },
  methods: {
    click(event, key) {
      if (
        event.target.clientWidth - event.offsetX < 32 &&
        event.target.clientHeight - event.offsetY < 32
      ) {
        this.$store.commit("dismissNotification", key);
      }
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants

.notificator
  position: sticky
  top: 0
  margin: -2rem auto 0 auto
  height: max-content
  max-width: 80%
  min-width: 100px
  overflow: hidden
  border-radius: 0 0 5px 5px

  .notification
    padding: 15px 30px
    text-align: center
    &:after
      content: "X"
      float: right
      margin-right: -15px
      padding-left: 20px
      cursor: pointer

    &.success
      background-color: $bc-primary
    &.note
      background-color: $bc-secondary
    &.warning
      background-color: $bc-warning
    &.danger
      background-color: $bc-danger
</style>
